import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navigation } from '../App';
import { Mail, Phone, MapPin, ArrowLeft } from 'lucide-react';

export default function ContactUs() {
  const navigate = useNavigate();
  // Load Go High Level form embed script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://links.roxvegas.cloud/js/form_embed.js';
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <div className="max-w-7xl mx-auto px-4 py-16">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-8 group"
        >
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          <span>Back</span>
        </button>
        
        <div className="mb-12 text-center">
          <div className="inline-flex items-center gap-3 bg-primary/10 border border-primary/30 rounded-full px-6 py-3 mb-6">
            <Mail className="w-6 h-6 text-primary" />
            <span className="text-primary font-semibold">Get In Touch</span>
          </div>
          <h1 className="text-5xl font-heading font-bold mb-6">Contact Us</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Have questions about our poker community? We're here to help!
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div className="lg:col-span-1 space-y-6">
            <div className="bg-card border border-border rounded-2xl p-8">
              <h2 className="text-2xl font-heading font-bold mb-6">Contact Information</h2>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Location</h3>
                    <p className="text-sm text-muted-foreground">
                      New Braunfels, TX 78130
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Email</h3>
                    <a 
                      href="mailto:info@luckorskills.com" 
                      className="text-sm text-primary hover:text-primary/80 transition-colors"
                    >
                      info@luckorskills.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Phone</h3>
                    <a 
                      href="tel:+18302372821" 
                      className="text-sm text-primary hover:text-primary/80 transition-colors"
                    >
                      (830) 237-2821
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border rounded-2xl p-8">
              <h3 className="font-semibold mb-3">Office Hours</h3>
              <div className="text-sm text-muted-foreground space-y-2">
                <div className="flex justify-between">
                  <span>Monday - Friday</span>
                  <span>9am - 6pm CST</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span>10am - 4pm CST</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span>Closed</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form - Go High Level Widget */}
          <div className="lg:col-span-2">
            <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-xl" style={{minHeight: '1035px'}}>
              <iframe
                src="https://links.roxvegas.cloud/widget/form/DDZsvnJB4Ll9HetJ2bEl"
                style={{width: '100%', height: '1035px', border: 'none', borderRadius: '4px'}}
                id="inline-DDZsvnJB4Ll9HetJ2bEl" 
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="On Form Submission_Luck_Or_Skills"
                data-height="1035"
                data-layout-iframe-id="inline-DDZsvnJB4Ll9HetJ2bEl"
                data-form-id="DDZsvnJB4Ll9HetJ2bEl"
                title="On Form Submission_Luck_Or_Skills"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}